import { useContext, useEffect, useRef, useState } from "react";
import { CellValueChangedEvent, ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { AuthContext } from "../../../../../../../../../../contexts";
import getAgGridHeight from "../../../../../../../../../../utils/commonFunctions/getAgGridHeight";
import { dateTimeZoneConverter } from "../../../../../../../../../../utils/commonFunctions/date";
import {
	handleDollarCellRenderer,
	handleLastUpdateDateCellRenderer
} from "../../../../../../../../../../utils/commonFunctions/cellRenderers";
import ROLES from "../../../../../../../../../../constants/roles";

const DependentHistoryVEBBenefitGrid = ({ historyVEBBenefits }: any) => {
	// console.log("DependentHistoryVEBBenefitGrid=====>", historyVEBBenefits);
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const [anchorEl, setAnchorEl] = useState<any>(null);
	const [coveredMembers, setCoveredMembers] = useState([]);
	const [gridHeight, setGridHeight] = useState("300px");

	const agGridRef = useRef<any>(null);
	const { user } = useContext(AuthContext);

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleDateCellRenderer = ({ value }: { value: string | null }) => {
		if (value === null) {
			return <div>N/A</div>;
		} else {
			return <div>{dateTimeZoneConverter(value as string) as string}</div>;
		}
	};

	const handleVEBBenefitEndDateCellRenderer = ({ value }: { value: string | "CURRENT" }) => {
		if (value === "CURRENT") {
			return <div>Current</div>;
		} else {
			return <div>{dateTimeZoneConverter(value as string) as string}</div>;
		}
	};

	useEffect(() => {
		const _gridHeight = getAgGridHeight(historyVEBBenefits.length);
		setGridHeight(_gridHeight);
	}, [historyVEBBenefits.length]);

	return (
		<div className="current-benefit-details-grid-container glb-tab-grid-container">
			<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
				<AgGridReact
					ref={agGridRef}
					rowData={historyVEBBenefits}
					onGridReady={handleAgGridReady}
					onFirstDataRendered={handleFirstDataRendered}
					rowSelection={"Single"}
					animateRows
					suppressColumnVirtualisation={true}
					defaultColDef={{
						filter: "agTextColumnFilter",
						floatingFilter: true,
						resizable: true
					}}
					onCellValueChanged={(params: CellValueChangedEvent) => {
						params.api.refreshCells({
							force: true,
							columns: ["covered_members"]
						});
					}}
					enableCellChangeFlash={true}
					frameworkComponents={{
						handleDateCellRenderer: handleDateCellRenderer,
						handleVEBBenefitEndDateCellRenderer: handleVEBBenefitEndDateCellRenderer,
						handleDollarCellRenderer: handleDollarCellRenderer,
						handleLastUpdateDateCellRenderer: handleLastUpdateDateCellRenderer
					}}
				>
					{user &&
					user.role === ROLES.super_admin &&
					((user.first_name === "Chitrak" && user.last_name === "Biswas") ||
						(user.first_name === "Anupam" && user.last_name === "Biswas") ||
						(user.first_name === "Rahul" && user.last_name === "Dutta") ||
						(user.first_name === "Suman" && user.last_name === "Dutta")) ? (
						<AgGridColumn
							field="group_number"
							headerName="Group Number"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit
						></AgGridColumn>
					) : null}
					<AgGridColumn
						field="base_plan_name"
						headerName="Base Plan Name"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field="plan_name"
						headerName="Plan Name"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field="sub_plan"
						headerName="Sub Plan"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field="plan_code"
						headerName="Plan Code"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field="enrollment_date"
						headerName="Enrollment Date"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						cellRenderer="handleDateCellRenderer"
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field="effective_date"
						headerName="Effective Date"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						cellRenderer="handleDateCellRenderer"
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field="benefit_end_date"
						headerName="Benefit End Date"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						cellRenderer="handleDateCellRenderer"
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field="benefit_end_reason"
						headerName="Benefit Termination Reason"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field="total_premium_amount"
						headerName="Premium Rate"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						cellRenderer="handleDollarCellRenderer"
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field="enrollment_status"
						headerName="Status"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field="createdAt"
						headerName="Created On"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						suppressSizeToFit={true}
						cellRenderer="handleLastUpdateDateCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field="agent_created_by"
						headerName="Created By"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field="updatedAt"
						headerName="Updated On"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						suppressSizeToFit={true}
						cellRenderer="handleLastUpdateDateCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field="plan_approved_by"
						headerName="Updated By"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						suppressSizeToFit={true}
					></AgGridColumn>
				</AgGridReact>
			</div>
		</div>
	);
};

export default DependentHistoryVEBBenefitGrid;
